import { c as _c } from "react-compiler-runtime";
import { forwardRef } from 'react';
import { AvatarRoot, AvatarFallback, AvatarImage } from './primitives';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Config-layer wrapper for `Avatar`. Accepts flat `src`, `alt`, and `fallback`
 * props instead of composing `AvatarImage` and `AvatarFallback` by hand.
 *
 * This component is part of Trellis's config API layer and covers the majority
 * of use cases. For advanced patterns, use the compositive API directly. If you
 * find yourself doing so, share your use case in #trellis-support — it directly
 * informs how we evolve the config layer.
 *
 * @see {@link AvatarRoot | Avatar}
 */
export const Avatar = /*#__PURE__*/forwardRef((t0, ref) => {
  const $ = _c(20);
  const {
    src,
    alt,
    fallback,
    fallbackDelay,
    backgroundColor,
    shape,
    size,
    truncated,
    id,
    ariaLabel,
    ariaLabelledby,
    ariaDescribedby,
    ariaDescription,
    dataTestId
  } = t0;
  const t1 = id === null || id === void 0 ? void 0 : id.root;
  const t2 = ariaLabel === null || ariaLabel === void 0 ? void 0 : ariaLabel.root;
  const t3 = ariaLabelledby === null || ariaLabelledby === void 0 ? void 0 : ariaLabelledby.root;
  const t4 = ariaDescribedby === null || ariaDescribedby === void 0 ? void 0 : ariaDescribedby.root;
  const t5 = ariaDescription === null || ariaDescription === void 0 ? void 0 : ariaDescription.root;
  const t6 = dataTestId === null || dataTestId === void 0 ? void 0 : dataTestId.root;
  let t7;
  if ($[0] !== alt || $[1] !== src) {
    t7 = src != null && /*#__PURE__*/_jsx(AvatarImage, {
      src: src,
      alt: alt !== null && alt !== void 0 ? alt : ""
    });
    $[0] = alt;
    $[1] = src;
    $[2] = t7;
  } else {
    t7 = $[2];
  }
  let t8;
  if ($[3] !== fallback || $[4] !== fallbackDelay) {
    t8 = fallback != null && /*#__PURE__*/_jsx(AvatarFallback, {
      delay: fallbackDelay,
      children: fallback
    });
    $[3] = fallback;
    $[4] = fallbackDelay;
    $[5] = t8;
  } else {
    t8 = $[5];
  }
  let t9;
  if ($[6] !== backgroundColor || $[7] !== ref || $[8] !== shape || $[9] !== size || $[10] !== t1 || $[11] !== t2 || $[12] !== t3 || $[13] !== t4 || $[14] !== t5 || $[15] !== t6 || $[16] !== t7 || $[17] !== t8 || $[18] !== truncated) {
    t9 = /*#__PURE__*/_jsxs(AvatarRoot, {
      ref: ref,
      backgroundColor: backgroundColor,
      shape: shape,
      size: size,
      truncated: truncated,
      id: t1,
      "aria-label": t2,
      "aria-labelledby": t3,
      "aria-describedby": t4,
      "aria-description": t5,
      "data-test-id": t6,
      children: [t7, t8]
    });
    $[6] = backgroundColor;
    $[7] = ref;
    $[8] = shape;
    $[9] = size;
    $[10] = t1;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
    $[17] = t8;
    $[18] = truncated;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  return t9;
});
Avatar.displayName = 'Avatar';